import styled from 'styled-components';
import { Icon } from '@digitools/honest-react';
export const DentalTileContainer = styled.div `
  ${({ active, theme, disabled }) => `
    background: white;
    box-shadow: 4px 4px 12px rgba(171.57, 171.57, 171.57, 0.15);
    border-radius: 4px;
    border: ${active ? '2px' : '0.5px'} solid ${active ? theme.palette.primary : theme.palette.grayLight}
    cursor: pointer;
    width: 100%;
    *{
      text-decoration: none;
    }
    @media (max-width: 780px) {
      padding: 0.5rem 0;
      display: block;
      height:100%;
      
    }
    @media (max-width: 1439px) and (min-width: 781px) {
      padding: 0.5rem 0;
      a {
        display:inline-block
      }
    }
    @media (min-width: 1440px) {
      height: 100%;
      padding: 0.5rem;
    }
     :active {
         background-color: ${disabled} ? 'none' : ${theme.palette.grayLightest};
      }
      :active * {
        color: ${disabled} ? ${theme.palette.gray} : ${theme.palette.primary} !important;
      }
   `}
`;
export const StyledDentalTile = styled.div `
  ${({ theme }) => `
      width: 100% !important;
      border: none;
      background-color: transparent;
      padding:0.5rem;
      color: black;
      :active {
        color: ${theme.primary};
      }
       &:hover {
         cursor: pointer;
      }
      @media (max-width: 780px) {
        align-items: center;
        width:100%;
        height:100%;
        text-align:center;
        padding:0;
      }
      @media (min-width: 1440px) {
        height:100%;
        display:flex;
        flex-direction:column;
        justify-content: space-between;
        margin:0;
      }
      `}
`;
export const DentalTileHeading = styled.div `
  @media (max-width: 1439px) and (min-width: 781px) {
    width: 100%;
    word-break: break-word;
    display: inline-block;
    align-content: center;
    padding: 0 0.5rem;
    text-align: left;
  }
  @media (min-width: 1440px) {
    height: 100%;
    display: inline-block;
    justify-content: space-between;
    text-align: left;
    padding: 0;
  }
  @media (max-width: 780px) {
    align-items: center;
    display: flex !important;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
  }
`;
export const DentalTileTitle = styled.p `
  ${({ theme, active, disabled }) => `
      margin-top: 0;
      margin-bottom: 0;
      font-weight: 500;
      letter-spacing: 0.15px;
      line-height: 19px;
      font-size: 1rem;
      color: ${active ? theme.palette.primary : disabled ? theme.palette.grey : theme.palette.secondary};
      @media (max-width: 1439px) and (min-width: 781px) {
        float: left;
        margin-left: 0.5rem;
      }
      @media (max-width: 780px) {
        margin-top:0.5rem;
        width: 100%;
        height:100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      @media (min-width: 1440px) {
        float: left;
        padding: 0;
        width: 100%;
        margin-top: 0.5rem
      }
      &:focus,
      &:hover {
          text-decoration: underline
          cursor: pointer;
          }`}
`;
export const StyledIcon = styled(Icon) `
  @media (max-width: 780px) {
    width: 100%;
    float: none;
  }
  @media (min-width: 781px) and (max-width: 1439px) {
    font-size: 1.5rem;
  }
`;
export const DentalTileText = styled.p `
  text-align: left;
  margin-bottom: 0;
  margin-top: 0;
  @media (min-width: 781px) and (max-width: 1439px) {
    padding-left: 0.5rem;
  }
`;
